import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../headerone/Main'
import Breadcrumb from '../Breadcrumb/Main'

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Coming soon"/>
            <section className="project-detail">
                <div className='container'>
                    {/* --- CHANGE BREDCOM {title, subtitle} and Write your code here ) --- */}
                    <h4>Coming soon...</h4>
                </div>
            </section>
        </>
    )
}

export default Main;